import * as UI from "@iyk/music-ui"

export const Meta = UI.Meta.withDefaults({
  title: "IYK for Artists",
  description:
    "Identify and connect with your top fans. Transform your live shows & merch into actionable insights.",
  image: "https://assets.iyk.app/music/iyk-music-og.jpg",
  url: "https://studio.iyk.app/music",
  domain: "studio.iyk.app"
})
